import { styled } from '@mui/material';

const RootDiv = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
}));

export default RootDiv;
